import { ApiInfo } from 'src/enums/apiInfo';
import { apiRequest } from 'src/utils/api';
import ApiRequest from 'core-api';
import authInfoSlice from 'src/redux/authInfoSlice';
import { store } from 'src/redux/store';

const url = ApiInfo.ME;

export const getMe = async (request: ApiRequest = apiRequest) => {
  const res = await request.get({
    url: url,
  });

  return res.data;
};

export const fetchInit = async (request: ApiRequest = apiRequest) => {
  //set Auth
  const { setAuthInfo } = authInfoSlice.actions;
  const res = await getMe(request);
  const data = res.data;
  store.dispatch(setAuthInfo(data));
};
